<button [id]="idVal" type="button" (click)="onClick.emit($event)" class="btn rounded-pill" [ngClass]="classes"
        [disabled]="this.disabled"
>
  {{ label }}
</button>
